var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-bar"},[_c('Row',[_c('sider-trigger',{attrs:{"collapsed":_vm.collapsed,"icon":"md-menu"},on:{"on-change":_vm.handleCollpasedChange}}),_c('Col',{attrs:{"span":"6"}},[_c('breadcrumb',{attrs:{"currentPath":_vm.levelList}})],1),_c('Col',[_c('div',{staticClass:"custom-content-con"},[_vm._t("default")],2)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }